import React, { useState, useEffect } from 'react';
import Header from '../../common/Header/Header';
import Tabs from '../../dashboard/Tabs/Tabs';
import Pagination from '../../dashboard/Pagination/Pagination';
import Container from '@mui/material/Container';
import filterByText from '../../../filters/filterByText';
import { useSelector } from "react-redux";
import Footer from '../../common/Footer/Footer';
import scrollToTop from '../../../functions/scrollToTop';

const Dashboard = () => {
  // Redux state to get the list of coins
  const coins = useSelector((state) => state.coins);

  // State variables for paginated coins, current page, and search text
  const [paginatedCoins, setPaginatedCoins] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState(""); 

  // Set the document title
  document.title = `Coins | InsightCoin`;

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    scrollToTop();
  },[]);

  // Update paginated coins whenever the current page changes
  const updatePaginatedCoins = () => {
    let arr = [...coins].splice((currentPage - 1) * 10, 10);
    setPaginatedCoins(arr);
    if (arr.length === 0 && currentPage >= 2) {
      setCurrentPage(currentPage - 1);
    }
  }

  // Fetch paginated coins when the current page changes
  useEffect(() => {
    updatePaginatedCoins();
    setSearchText("");
  }, [currentPage]);

  // Update paginated coins when the list of coins changes
  useEffect(() => {
    if (searchText === "") {
      updatePaginatedCoins();
    } else {
      handleSearchBar({target:{value: searchText}});
    }
  }, [coins]);

  // Handle search bar input changes
  const handleSearchBar = (e) => {
    let text = e.target.value;
    setSearchText(text);
    if (text === "") {
      updatePaginatedCoins();
    } else {
      let filteredCoins = filterByText(text, [...coins]);
      setPaginatedCoins([...filteredCoins].splice(0, 8));
    }
  }

  // Handle page change in pagination
  const handlePageChange = (event, page) => {
    scrollToTop();
    setCurrentPage(page);
  };

  // JSX structure for the Dashboard component
  return (
    <>
      {/* Header component */}
      <Header />
      {/* Container for displaying tabs with paginated coins */}
      <Container maxWidth="lg">
        <Tabs coins={paginatedCoins} searchText={searchText} handleSearchBar={handleSearchBar} />
      </Container>
      {/* Pagination component for navigating through pages */}
      <Pagination handlePageChange={handlePageChange} page={currentPage} />
      {/* Footer component */}
      <Footer/>
    </>
  );
}

export default Dashboard;
